import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const maxWidthWrapperVariants = cva('mx-auto', {
  variants: {
    size: {
      sm: 'max-w-2xl px-4',
      md: 'max-w-4xl px-4 md:px-8',
      lg: 'max-w-6xl px-4 md:px-8',
      xl: 'max-w-7xl px-4 md:px-8',
    },
    fullWidth: {
      true: '',
      false: '',
    },
    noPadding: {
      true: '',
      false: '',
    },
  },
  defaultVariants: {
    size: 'md',
    fullWidth: false,
    noPadding: false,
  },
  compoundVariants: [
    {
      fullWidth: true,
      class: '!max-w-full',
    },
    {
      noPadding: true,
      class: '!px-0',
    },
  ],
})

export interface MaxWidthWrapperProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof maxWidthWrapperVariants> {}

export function MaxWidthWrapper({
  children,
  className,
  size,
  fullWidth,
  noPadding,
  ...props
}: MaxWidthWrapperProps) {
  return (
    <div
      className={cn(maxWidthWrapperVariants({ size, fullWidth, noPadding }), className)}
      {...props}
    >
      {children}
    </div>
  )
}
